import BoltBanner from "../boltClone/BoltBanner";
import BoltOwnCode from "../boltClone/BoltOwnCode";
import { lazy, Suspense } from "react";

const LyftTeamlogo = lazy(() => import("../LyftClone/LyftTeamlogo"));
const BoltSuperlative = lazy(() => import("../boltClone/BoltSuperlative"));
const BoltNeed = lazy(() => import("../boltClone/BoltNeed"));
const BoltDrive = lazy(() => import("../boltClone/BoltDrive"));
const BoltJourney = lazy(() => import("../boltClone/BoltJourney"));
const BoltBuild = lazy(() => import("../boltClone/BoltBuild"));
const BoltForYou = lazy(() => import("../boltClone/BoltForYou"));
const BoltDevelopement = lazy(() => import("../boltClone/BoltDevelopement"));
const BoltCustom = lazy(() => import("../boltClone/BoltCustom"));
const BoltSmart = lazy(() => import("../boltClone/BoltSmart"));
const BoltWhiteLabel = lazy(() => import("../boltClone/BoltWhiteLabel"));
const BoltGen = lazy(() => import("../boltClone/BoltGen"));
const BoltGlobal = lazy(() => import("../boltClone/BoltGlobal"));
const ShuttleAppreciation = lazy(() => import("../../shuttle_software/ShuttleAppreciation"));
const TaxiFaq = lazy(() => import("../../taxiDispatchSoftware/TaxiFaq"));

const bannerData = {
  class: "bolt-banner",
  titlePart1: "Easy Taxi Clone App",
  titlePart2: "Development Company",
  description: "Leading experts in creating scalable, secure, and fully customizable taxi booking apps tailored for seamless user experiences.",
  image: "/assets/home/bolt-banner.webp",
  btn1: "contact us",
  btn2: "watch demo",
  counter1: {
    number: "2000+",
    text: "Apps Launched"
  },
  counter2: {
    number: "100+",
    text: "Expert Developers"
  },
  counter3: {
    number: "250+",
    text: "Happy Clients"
  },
  breadcrumbData: {
    newClass: "white-breadcrumb",
    list: [
      {
        page: "Home",
        slug: "/"
      },
      {
        page: "easy taxi Clone App",
        slug: ""
      },
    ]
  }
};

const OwnCodeData = {
  box1: {
    image: "/assets/home/bolt-own-code-1.webp",
    title: "Own the Entire Source Code",
  },
  box2: {
    image: "/assets/home/bolt-own-code-2.webp",
    title: "Outstanding UI & Superior UX",
  },
  box3: {
    image: "/assets/home/bolt-own-code-3.webp",
    title: "Fully Customized Solution",
  },
  box4: {
    image: "/assets/home/bolt-own-code-4.webp",
    title: "Next-Level Features",
  },
}

const superlativeData = {
  titlePart1: "Why",
  titlePart2: "Easy Taxi Clone App",
  titlePart3: "Superlative For Taxi Booking Businesses?",
  description1: "In Brazil’s bustling cities, where urban transport plays a crucial role in everyday life, speed, reliability, and convenience define customer satisfaction. That’s where the Easy Taxi Clone App by Mobility Infotech emerges as a revolutionary solution. Purpose-built for the Brazilian market, our cutting-edge clone delivers a high-performance, all-in-one ride-hailing platform that competes with global giants in both functionality and user experience. Whether you’re launching a new taxi venture in São Paulo or digitizing your fleet in Rio de Janeiro, our Easy Taxi Clone App empowers you with a robust system. Instant ride-matching, real-time tracking, secure digital payments—every feature is tuned for smooth, intuitive experiences for drivers and passengers alike.",
  description2: "What makes this solution exceptional isn’t just the tech stack—it’s the strategic business leverage it offers. With support for Portuguese language, custom branding, regional payment integrations like PIX, and geo-fencing, your business can quickly capture local markets. The app is built for scale, ready to grow with you across Brazil’s diverse cities and transportation needs. In a highly competitive space, tech is your advantage. Choose Mobility Infotech’s Easy Taxi Clone App—the smarter, faster, and more scalable route to ride-hailing success in Brazil.",
}

const needData = {
  titlePart1: "Taxi",
  titlePart2: "App Development Solutions",
  titlePart3: "for Every Business Need",
  description: "Powering Canada’s transportation evolution—one ride at a time.",
  boxes: [
    {
      image: "/assets/home/bolt-need-1.webp",
      title: "On-Demand Taxi Booking Apps",
      para: "Offer real-time taxi booking with instant ride-matching and GPS-based tracking. Perfect for startups looking to provide Easy Taxi-like service across Brazil’s major urban hubs.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-2.webp",
      title: "Ride-sharing or Carpooling Apps",
      para: "Enable cost-effective commuting with smart ride-sharing features, fare splitting, and route optimization—ideal for eco-conscious Brazilians.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-3.webp",
      title: "Corporate Taxi Booking Apps",
      para: "Create enterprise-grade taxi booking systems for businesses with invoice management, ride tracking, and HR control for employee travel.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-4.webp",
      title: "Rental or Hourly Taxi Booking Apps",
      para: "Let users hire taxis by the hour for city tours or flexible intercity travel—suitable for tourists, professionals, and event-goers.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-5.webp",
      title: "Luxury & Limousine Booking Apps",
      para: "Tap into Brazil’s elite clientele with luxury car bookings, real-time chauffeur tracking, and premium ride experiences.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-6.webp",
      title: "Bike Taxi Booking Apps",
      para: "Deploy affordable, fast bike taxis for solo commuters navigating high-traffic cities like São Paulo and Recife.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-7.webp",
      title: "White-Label Taxi Booking Apps",
      para: "Launch your own brand with a custom-built, ready-to-deploy white label solution—logo, UI, and features tailored for your audience.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-8.webp",
      title: "Airport Transfer Taxi Apps",
      para: "Integrate flight tracking, driver alerts, and ride scheduling for airport transfers—ideal for airports like GRU or SDU.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-9.webp",
      title: "Electric Vehicle (EV) Taxi Apps",
      para: "Promote Brazil’s green transport movement with EV-compatible features like charging station integration and low-emission options.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-10.webp",
      title: "Paratransit or Accessible Taxi Apps",
      para: "Cater to passengers with special mobility needs—equipped with driver assistance features and compliance with Brazil’s accessibility standards.",
      btn: "Request a free demo",
    },
  ],
}

const driveData = {
  titlePart1: "Drive Your Success with Brazil’s ",
  titlePart2: "Leading Taxi App Development Experts",
  description: "Embrace smart mobility with next-gen taxi app solutions and see tangible results:",
  image: "/assets/home/bolt-drive.webp",
  vector: "/assets/home/bolt-drive-vec.webp",
  boxes: [
    {
      image: "/assets/home/drive-circle-1.webp",
      title: "60% Rise in Ride Bookings Per Quarter",
    },
    {
      image: "/assets/home/drive-circle-2.webp",
      title: "45% Reduction in Average Pickup Times",
    },
    {
      image: "/assets/home/drive-circle-3.webp",
      title: "35% Lower Operational Costs",
    },
    {
      image: "/assets/home/drive-circle-4.webp",
      title: "44% Boost in Revenue Generation",
    },
    {
      image: "/assets/home/drive-circle-5.webp",
      title: "75% Rise in Customer Loyalty and Repeat Rides",
    },
    {
      image: "/assets/home/drive-circle-6.webp",
      title: "58% Growth in Positive Customer Feedback Every Quarter",
    },
  ],
}

const journeyData = {
  titlePart1: "Our Taxi App Development Process That",
  titlePart2: "Drives Your Business Forward",
  description: "Planning to launch an Easy Taxi-style app in Brazil? Here’s how our process flows, ensuring operational clarity and passenger satisfaction:",
  image: "/assets/home/bolt-journey.webp",
  vector: "/assets/home/bolt-journey-vec.webp",
}

const buildData = {
  titlePart1: "We Build Taxi Booking Apps",
  titlePart2: "Using Advanced Features",
  description: "Mobility Infotech integrates powerful technologies into your Easy Taxi Clone App to deliver secure, scalable, and smooth operations:",
  btn: "more features",
  tabs: [{
    title: "AI-Powered Route Optimization",
    description: "AI helps drivers choose faster, traffic-free routes—perfect for Brazil’s congested cities.",
    icon: "/assets/home/bolt-build-icon-1.webp",
    image: "/assets/home/bolt-build-1.webp",
  },
  {
    title: "IoT for Vehicle Tracking",
    description: "Real-time tracking, driver monitoring, and maintenance alerts ensure safety and efficiency.",
    icon: "/assets/home/bolt-build-icon-2.webp",
    image: "/assets/home/bolt-build-2.webp",
  },
  {
    title: "Chatbots for Customer Support",
    description: "Multilingual AI chatbots (including Portuguese) assist with bookings, cancellations, and support—24/7.",
    icon: "/assets/home/bolt-build-icon-3.webp",
    image: "/assets/home/bolt-build-3.webp",
  },
  {
    title: "Blockchain for Secure Payments",
    description: "Enable secure, fraud-proof transactions using blockchain, building trust among riders and drivers.",
    icon: "/assets/home/bolt-build-icon-4.webp",
    image: "/assets/home/bolt-build-4.webp",
  },
  {
    title: "Intelligent Driver Matching System",
    description: "Our matching system reduces passenger wait time and enhances trip quality based on proximity and driver ratings.",
    icon: "/assets/home/bolt-build-icon-5.webp",
    image: "/assets/home/bolt-build-5.webp",
  },
  {
    title: "AR for Enhanced Navigation",
    description: "Use AR overlays for street-level guidance—especially effective in large and confusing urban zones.",
    icon: "/assets/home/bolt-build-icon-6.webp",
    image: "/assets/home/bolt-build-6.webp",
  },],
}

const forYouData = {
  newClass: "bolt-for-you",
  text: "Mobility Infotech Will",
  text2: "Build a White-Label Taxi Booking",
  title: "App Just for You",
  btn: "BEGIN NOW!",
}

const developementData = {
  titlePart1: "Key Features of Our ",
  titlePart2: "Easy Taxi Clone App ",
  titlePart3: "Development",
  description: "Join hands with Mobility Infotech to build a powerful, scalable, and future-ready taxi app inspired by Easy Taxi, specially crafted for the Brazilian market. From seamless ride bookings and real-time driver tracking to local payment integrations like PIX, our feature-rich solution empowers your taxi business to grow efficiently and operate smoothly across Brazil.",
  btn: "Get Started",
  customer: {
    image: "/assets/home/bolt-developement-1.webp",
    title: "Customer App",
    description: "Your customers enjoy a seamless experience with an intuitive interface and essential ride features, all powered by modern tech that enhances convenience, safety, and trust.",
    boxes: [
      {
        title: "Seamless Ride Booking",
        desc: "Let users book rides effortlessly through an intuitive interface that mirrors the simplicity of Brazil’s most popular apps."
      },
      {
        title: "Flexible Payment Options",
        desc: "Integrated with Brazil’s preferred payment systems such as PIX, debit/credit cards, and in-app wallets for maximum convenience and security."
      },
      {
        title: "Live Trip Sharing",
        desc: "Real-time map updates allow passengers to track their ride's location and ETA with pinpoint accuracy."
      },
      {
        title: "Schedule Rides in Advance",
        desc: "Enable users to pre-book rides for specific times — ideal for airport runs, early meetings, and planned outings."
      },
      {
        title: "Trip Sharing for Safety",
        desc: "Customers can share their ride status and real-time trip progress with friends and family for enhanced safety and transparency."
      },
      {
        title: "Push Notifications",
        desc: "Instant alerts for ride confirmations, driver details, estimated arrival times, and promotional campaigns to keep users informed and engaged."
      },
    ]
  },
  driver: {
    image: "/assets/home/bolt-developement-2.webp",
    title: "Driver App",
    description: "Our driver-focused Easy Taxi clone app empowers your drivers to manage rides efficiently while ensuring smooth, profitable journeys.",
    boxes: [
      {
        title: "Direct Calling",
        desc: "Drivers can call passengers directly through the app for quicker coordination during pickups."
      },
      {
        title: "Optimized Route Navigation",
        desc: "Smart route assistance with real-time traffic updates, optimized for busy roads in cities like Recife, Curitiba, and Fortaleza."
      },
      {
        title: "Start & End Ride Tracking",
        desc: "Drivers can manage ride flow with a single tap to start or end trips, keeping records accurate and timely."
      },
      {
        title: "Built-In Help & Support",
        desc: "Access in-app support for directions, payments, and app usage to ensure every ride runs smoothly."
      },
      {
        title: "Earnings Dashboard",
        desc: "Drivers get detailed insights into their earnings, trip history, and payment status directly from their dashboard."
      },
      {
        title: "In-App Chat",
        desc: "Secure, real-time messaging between driver and rider ensures efficient coordination without leaving the app."
      },
    ]
  },
  dispatcher: {
    image: "/assets/home/bolt-developement-3.webp",
    title: "Dispatcher Dashboard",
    description: "Our centralized and intelligent dispatcher console lets you monitor and manage every trip, vehicle, and driver in real time.",
    boxes: [
      {
        title: "Automatic Dispatching",
        desc: "Automatically assign the nearest available driver to each request, minimizing wait times and optimizing fleet efficiency."
      },
      {
        title: "Booking Management",
        desc: "Track and manage all incoming ride requests with full visibility and control over dispatching in real time."
      },
      {
        title: "Live Fleet Tracking",
        desc: "View and manage your entire fleet live on a dynamic map—ideal for operations in major Brazilian metropolitan areas."
      },
      {
        title: "Push Alerts for Dispatch",
        desc: "Send updates, trip assignments, or urgent messages to one or multiple drivers instantly through the dashboard."
      },
      {
        title: "Smart Route Planning",
        desc: "Utilize advanced route optimization tools to reduce traffic delays, improve fuel efficiency, and speed up response times."
      },
      {
        title: "Complete Transaction History",
        desc: "Access detailed records of all completed, pending, and canceled rides, with full fare and duration breakdowns."
      },
    ]
  },
  admin: {
    image: "/assets/home/bolt-developement-4.webp",
    title: "Admin Panel",
    description: "Gain full control of your Easy Taxi clone app with a powerful admin panel to oversee operations, analytics, and business performance.",
    boxes: [
      {
        title: "Driver Supervision",
        desc: "Easily manage driver accounts—add, verify, assign, or deactivate based on city coverage and service demand."
      },
      {
        title: "In-Depth Analytics",
        desc: "Access detailed insights into trip volumes, revenue generation, customer activity, and driver performance metrics."
      },
      {
        title: "Integrated Payment Management",
        desc: "Securely handle all financial transactions using Brazil’s leading payment systems, including Pix and credit integrations."
      },
      {
        title: "Promo & Loyalty Management",
        desc: "Create and manage promotional codes, discounts, and loyalty programs to attract and retain riders."
      },
      {
        title: "Real-Time Admin Chat",
        desc: "Communicate instantly with drivers or dispatchers to troubleshoot, give instructions, or resolve issues efficiently."
      },
      {
        title: "Booking Oversight",
        desc: "Monitor, edit, and approve all bookings and dispatches in real time, ensuring a smooth operation across cities."
      },
    ]
  },
}

const customData = {
  titlePart1: "Serving Diverse Industries",
  titlePart2: "with Easy Taxi Clone App Solutions",
  description: "Whether you're managing a local fleet, a corporate transport system, or planning large-scale events, Mobility Infotech delivers customized, scalable taxi app solutions built to enhance experiences and streamline operations across Brazil.",
  slides: [
    {
      image: "/assets/home/bolt-custom-slide-1.webp",
      title: "Corporate Transportation Providers",
      desc: "Support Brazilian businesses with smooth and cost-efficient employee commute solutions. Enable shift-wise scheduling, ride tracking, invoicing, and admin controls — all through one smart platform tailored for corporate mobility.",
    },
    {
      image: "/assets/home/bolt-custom-slide-2.webp",
      title: "Taxi App for fleet Businesses",
      desc: "Scale your taxi operations anywhere in Brazil with our Easy Taxi Clone App. Empower your fleet with dynamic ride dispatching, driver performance analytics, and automated fare settlements, all while maintaining high service standards.",
    },
    {
      image: "/assets/home/bolt-custom-slide-3.webp",
      title: "Events Transportation Providers",
      desc: "From destination weddings in Rio to corporate summits in São Paulo, manage event logistics effortlessly with automated ride scheduling, live GPS tracking, and a centralized control panel that ensures timely pickups and a smooth guest experience.",
    },
    {
      image: "/assets/home/bolt-custom-slide-4.webp",
      title: "School And College Operation",
      desc: "Prioritize student safety with real-time route tracking, instant alerts to parents and admins, and trip monitoring. Our Easy Taxi Clone App makes school transportation secure, visible, and reliable for institutions across Brazil.",
    },
    {
      image: "/assets/home/bolt-custom-slide-5.webp",
      title: "Tour & Travel Operation",
      desc: "Offer seamless travel experiences for tourists with live driver tracking, flexible route planning, and efficient coordination between guides and groups. Ideal for Brazil’s vibrant travel industry—from Amazon eco-tours to city sightseeing.",
    },
  ]
}

const smartData = {
  titlePart1: "Where",
  titlePart2: "Smart Mobility Meets",
  titlePart3: "Profitable App Business Models",
  description: "Revenue Streams You Can Tap Into With Our Easy Taxi Clone App:",
  boxes: [
    {
      image: "/assets/home/bolt-smart-1.webp",
      title: "Trip Commissions",
      desc: "Earn a set percentage from every successful ride completed via the app.",
    },
    {
      image: "/assets/home/bolt-smart-2.webp",
      title: "Surge Pricing",
      desc: "Boost your revenue by charging premium fares during peak hours, weekends, and special events.",
    },
    {
      image: "/assets/home/bolt-smart-3.webp",
      title: "Premium Bookings",
      desc: "Add higher fare brackets for luxury, SUV, or executive car bookings to cater to Brazil’s diverse customer segments.",
    },
    {
      image: "/assets/home/bolt-smart-4.webp",
      title: "Cancellation Fees",
      desc: "Offset lost time and operational disruptions by charging fees for last-minute cancellations.",
    },
    {
      image: "/assets/home/bolt-smart-5.webp",
      title: "Leasing to Drivers",
      desc: "Provide vehicle leasing options to drivers, enabling more people to join your platform while generating consistent income.",
    },
    {
      image: "/assets/home/bolt-smart-6.webp",
      title: "Brand Advertising",
      desc: "Offer promotional spaces for local brands or services within your app, creating new advertising revenue streams.",
    },
  ]
}

const WhiteLabelData = {
  title: "Develop Your White-Label Taxi Dispatch App with Mobility Infotech",
  description: "Why Brazilian taxi businesses choose us:",
  boxes: [
    {
      image: "/assets/home/bolt-white-1.webp",
      title: "White-Label Solution",
      desc: "We build the app under your name and design — no traces of our brand, giving you full ownership.",
    },
    {
      image: "/assets/home/bolt-white-2.webp",
      title: "Ready To Use",
      desc: "Get your Easy Taxi Clone App ready and operational within 72 hours, ensuring rapid entry into Brazil’s market.",
    },
    {
      image: "/assets/home/bolt-white-3.webp",
      title: "Highly Scalable",
      desc: "Whether you're starting in São Paulo or Salvador, the app scales with you — city by city, state by state.",
    },
    {
      image: "/assets/home/bolt-white-4.webp",
      title: "Seamless Integration",
      desc: "We connect your app with any existing services or tools your business uses — from CRM systems to local payment APIs.",
    },
    {
      image: "/assets/home/bolt-white-5.webp",
      title: "Fully Customizable",
      desc: "Customize functionalities, add modules, or localise the language and design to suit Brazil’s unique user habits.",
    },
    {
      image: "/assets/home/bolt-white-6.webp",
      title: "User-Friendly Interface",
      desc: "Clean, intuitive design ensures that every user — from tech-savvy Gen Z to first-time users — can navigate with ease.",
    },
  ]
}

const genData = {
  titlePart1: "Next-Gen",
  titlePart2: "Taxi App Development",
  titlePart3: "Company Driving Innovation",
  description: "With Mobility Infotech, build your Easy Taxi Clone App and grow smarter:",
  boxes: [
    {
      image: "/assets/home/lyft-minimum-1.webp",
      title: "Automate dispatch and driver allocation.",
    },
    {
      image: "/assets/home/lyft-minimum-2.webp",
      title: "Track drivers in real time via GPS.",
    },
    {
      image: "/assets/home/lyft-minimum-3.webp",
      title: "Monitor operations with smart dashboards.",
    },
    {
      image: "/assets/home/lyft-minimum-4.webp",
      title: "Use analytics for data-driven decisions.",
    },
    {
      image: "/assets/home/lyft-minimum-5.webp",
      title: "Accept Interac, Apple Pay, Google Pay, and more.",
    },
    {
      image: "/assets/home/lyft-minimum-6.webp",
      title: "Build trust with ride ratings and feedback.",
    },
  ],
}

const globalData = {
  titlePart1: "Proven Impact from",
  titlePart2: "Our Taxi App",
  titlePart3: "Development",
  counter1: {
    number: "70",
    text: "Increase in Potential ROI",
  },
  counter2: {
    number: "64",
    text: "Increase in Customer Satisfaction",
  },
  counter3: {
    number: "40",
    text: "Increase in Bookings",
  },
  counter4: {
    number: "20",
    text: "Reduction in Maintenance Cost",
  },
}

const faqData = [
  {
    id: "0",
    question: "01. What is Mobility Infotech’s Easy Taxi Clone App?",
    answer: "It is a fully customizable, feature-rich ride-hailing app built for the Brazilian market to replicate the best of Easy Taxi's services.",
  },
  {
    id: "1",
    question: "02. Why choose Mobility Infotech for taxi app development in Brazil?",
    answer: "We offer proven experience, quick deployment, robust tech, and complete localization for the Brazilian audience.",
  },
  {
    id: "2",
    question: "03. Can the Easy Taxi Clone App be customized for my brand?",
    answer: "Yes. From UI to payment systems and feature sets, every element is tailored to your business goals.",
  },
  {
    id: "3",
    question: "04. Is post-launch support available?",
    answer: "Absolutely. We offer 24/7 technical support, regular updates, and app maintenance.",
  },
  {
    id: "4",
    question: "05. How quickly can the app be launched?",
    answer: "You can go live within 3 days using our white-label, ready-to-deploy clone solution.",
  },
  {
    id: "5",
    question: "06. Can it integrate with existing tools or platforms?",
    answer: "Yes. We ensure smooth integration with your payment gateways, CRM, and backend systems.",
  },
  {
    id: "6",
    question: "07. What technologies are used in the app?",
    answer: "We use AI, IoT, blockchain, chatbots, and AR navigation for an advanced experience.",
  },
  {
    id: "7",
    question: "08. Is the app secure?",
    answer: "Yes. It includes end-to-end encryption, secure gateways, blockchain payments, and fraud detection features.",
  },
];

export default function EasyTaxi() {
  return (
    <>
      <BoltBanner data={bannerData} />
      <BoltOwnCode data={OwnCodeData} />

      <Suspense fallback={null}>
        <LyftTeamlogo heading={true} newClass="bolt-clone-team" />
        <BoltSuperlative data={superlativeData} />
        <BoltNeed data={needData} />
        <BoltDrive data={driveData} />
        <BoltJourney data={journeyData} />
        <BoltBuild data={buildData} />
        <BoltForYou data={forYouData} />
        <BoltDevelopement data={developementData} />
        <BoltCustom data={customData} />
        <BoltSmart data={smartData} />
        <BoltWhiteLabel data={WhiteLabelData} />
        <BoltGen data={genData} />
        <BoltGlobal data={globalData} />
        <ShuttleAppreciation />
        <div className="zip-faq-fixer">
          <TaxiFaq faqData={faqData} />
        </div>
      </Suspense>
    </>
  )
}
